import React, { useState } from 'react';
import Container from './container';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';


const HomePageSection = ({ title, subtitle, content }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="w-full bg-blue-40 dark:bg-blue-600 py-8">
      <Container className="flex flex-col items-start text-left">
        {title && (
          <h2 className="max-w-2xl text-3xl font-bold leading-snug tracking-tight text-blue-900 lg:leading-tight lg:text-4xl dark:text-white text-left">
            {title}
          </h2>
        )}

        {subtitle && (
          <div className="max-w-2xl mt-2 text-lg text-gray-600 lg:text-xl xl:text-xl text-left dark:text-gray-200">
            {parse(subtitle)}
          </div>
        )}

        <div className="w-full max-w-2xl relative">
          
          <div className={`overflow-hidden transition-all duration-500 ease-in-out ${
            isExpanded ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}>
            {content && (
              <div className="text-justified text-lg text-gray-600 lg:text-xl xl:text-xl dark:text-white mb-4">
                {parse(content)}
              </div>
            )}
          </div>

          <hr className="my-4 border-blue-900 dark:border-yellow-700" />

          <div className="w-full text-right">
            {!isExpanded ? (
              <button 
                onClick={toggleExpand} 
                className="text-gray-500 dark:text-yellow-700 hover:text-gray-700 underline transition-colors duration-300"
              >
                {t('what-is-osiris-section-read-more')}
              </button>
            ) : (
              <button 
                onClick={toggleExpand} 
                className="text-gray-500 dark:text-yellow-700 hover:text-gray-700 underline transition-colors duration-300"
              >
                {t('what-is-osiris-section-close')}
              </button>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HomePageSection;